import { datadogLogs } from '@datadog/browser-logs';
import { useEffect, useState } from 'react';

const useIovation = () => {
  const [ioBlackBox, setIoBlackBox] = useState<string>();

  useEffect(() => {
    const iovationConfig: any = {
      bbout_element_id: 'ioBlackBox',
      enable_rip: true,
      enable_flash: false,
      install_flash: false,
      loader: {
        version: 'general5',
      },
    };

    if (import.meta.env.VITE_IOVATION_SERVER_INTEGRATION !== 'true') {
      /** Loads iovation scripts from current domain proxy or from third-party domain */
      iovationConfig.loader.fp_static = false;
    }

    (window as any).IGLOO = (window as any).IGLOO || iovationConfig;

    (window as any).IGLOO.bb_callback = function (
      blackBoxString: string,
      isComplete: boolean,
    ) {
      if (isComplete) {
        setIoBlackBox(blackBoxString);
      }
    };

    const scriptNode = document.createElement('script');
    scriptNode.async = true;
    scriptNode.type = 'text/javascript';
    scriptNode.src = `${window.location.origin}/js/iojs-loader.js`;

    const firstScript: HTMLScriptElement =
      document.getElementsByTagName('script')[0];

    if (firstScript && firstScript.parentNode && scriptNode) {
      firstScript.parentNode.insertBefore(scriptNode, firstScript);
      datadogLogs.logger.info('IOVATION script injected');
    }

    return () => {
      scriptNode.remove();
    };
  }, []);

  return {
    ioBlackBox,
  };
};

export default useIovation;
